import React from 'react';

const DevAccessDenied: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg border border-red-200 p-8 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg 
              style={{ width: '2rem', height: '2rem' }}
              className="w-8 h-8 text-red-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Development Environment
          </h1>
          <p className="text-gray-600">
            This is a development environment with restricted access.
          </p>
        </div>
        
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-yellow-800">
            <strong>Access Restricted:</strong> This environment is for development purposes only.
          </p>
        </div>
        
        <div className="text-sm text-gray-500">
          <p>If you need access, please contact the development team.</p>
          <p className="mt-2">
            Admin access available at: 
            <a 
              href="/admin" 
              className="text-blue-600 hover:text-blue-800 font-medium ml-1"
            >
              /admin
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DevAccessDenied;
